var map = {
	"./appbar_cathedral.png": 7441,
	"./appbar_crimson.png": 3542,
	"./appbar_skolhive.png": 3724,
	"./favicon.ico": 2177,
	"./inventory.png": 6838,
	"./logosmall_cathedral.png": 4689,
	"./logosmall_crimson.png": 4582,
	"./logosmall_skolhive - Copy.png": 6118,
	"./onlylogo_cathedral.png": 46,
	"./onlylogo_crimson.png": 121,
	"./onlylogo_skolhive.png": 1689,
	"./parents.png": 765,
	"./principal.jpg": 1996,
	"./sidebar_cathedral.png": 9875,
	"./sidebar_crimson.png": 9556,
	"./sidebar_skolhive.png": 2962,
	"./students.png": 5248,
	"./support.png": 5315,
	"./teacher.jpg": 7000,
	"./teacher.png": 5692,
	"./worker.png": 1342,
	"./xl.png": 0
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;